import styled from "styled-components";
import { colors } from "@/theme";

export const CounterContainer = styled.div`
  display: inline-flex;
  height: 24px;
  padding: 0 8px;
  justify-content: center;
  align-items: center;
  gap: 3px;
  border-radius: 999px;
  background: ${colors.neutralGrey100};
`;

export const CounterRemove = styled.div`
  display: flex;
  height: 24px;
  padding-right: 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const CounterBody = styled.div`
  width: 20px;
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const CounterAdd = styled.div`
  display: flex;
  height: 24px;
  padding-left: 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
